function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/companies/{id}/business_units', {
  only: ['all']
});
const businessUnitsService = {
  useFetchAll: _ref => {
    let {
      companyId,
      setLoading,
      fetchImmediately = true
    } = _ref;
    const [businessUnits, setBusinessUnits, fetchBusinessUnits, pages] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.all(companyId), [companyId]),
      setLoading,
      fetchImmediately,
      paginationResourceField: 'business_units'
    });
    return [businessUnits, setBusinessUnits, fetchBusinessUnits, pages];
  },
  useFetchBusinessUnit(companyId, businessUnitId, setLoading) {
    const [businessUnit, setBusinessUnit] = useState(null);
    const fetchBusinessUnit = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      const unit = await businessUnitsService.get(companyId, businessUnitId);
      setBusinessUnit(unit);
      setLoading && setLoading(false);
    }, [companyId, businessUnitId, setLoading]), useCallback(async () => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchBusinessUnit();
    }, [fetchBusinessUnit]);
    return [businessUnit, setBusinessUnit];
  },
  useUpdateBusinessUnit(companyId, setBusinessUnit) {
    const updateBusinessUnit = useErrorHandling(useCallback(async unit => {
      const updatedUnit = await businessUnitsService.update(companyId, unit);
      setBusinessUnit(updatedUnit);
    }, [companyId, setBusinessUnit]));
    return updateBusinessUnit;
  },
  create(companyId, business_unit) {
    return fetch("/api/companies/".concat(companyId, "/business_units"), _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        business_unit
      })
    }));
  },
  get(companyId, business_unit_id) {
    return fetch("/api/companies/".concat(companyId, "/business_units/").concat(business_unit_id), _objectSpread({}, request.get));
  },
  delete(companyId, business_unit_id) {
    return fetch("/api/companies/".concat(companyId, "/business_units/").concat(business_unit_id), _objectSpread({}, request.delete));
  },
  update(companyId, business_unit) {
    return fetch("/api/companies/".concat(companyId, "/business_units/").concat(business_unit.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        business_unit
      })
    }));
  },
  all(companyId) {
    let queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const url = "/api/companies/".concat(companyId, "/business_units").concat(queryString ? "?".concat(queryString) : '');
    return fetch(url, _objectSpread({}, request.get));
  }
};
export default businessUnitsService;